<mat-card style="box-shadow:none;    padding: 0px !important;" [class.mat-elevation-z1]="'true'">
    <mat-card-header>
      <span mat-card-avatar>
        <mat-icon>question_answer</mat-icon>
      </span>
      <mat-card-title>{{ modalTitle }}</mat-card-title>
    </mat-card-header>
    <div>
        <p>{{ data.confirmationText }}</p>
    </div>
    <div>
        <p>{{ data.subConfirmationText }}</p>
    </div>
    <mat-form-field *ngIf="changeComponent" class="ple">
        <mat-label style="font-size: 15px !important;">Priority</mat-label>
        <mat-select [(value)]="priority" panelClass="custom-panel">
            <mat-option value="low">Low</mat-option>
            <mat-option value="high">High</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-divider></mat-divider>
    <div class="mat-card-actions-container">
      <mat-card-actions>
        <div fxLayout="row">
          <span fxFlex></span>
          <button type="button" mat-raised-button (click)="back()" class="text-upper">{{cancelBtn}}</button>
          <button mat-raised-button  *ngIf="buttonType !== 'Locked'" (click)="save()"
            color="accent"
            class="text-upper">{{submitTitle}}</button>
        </div>
      </mat-card-actions>
    </div>
</mat-card>
